import { useState, useRef, useCallback } from 'react'

export const useMultiCollapsible = (initialState = {}) => {
  const [openStates, setOpenStates] = useState(initialState)
  const refs = useRef({})
  const handleCollapse = useCallback((_id) => {
    const elem = refs.current[_id]
    if (!elem) return
    elem.style.height = ''
    elem.style.transition = 'none'
    const startHeight = window.getComputedStyle(elem).height
    elem.classList.toggle('active')
    const height = window.getComputedStyle(elem).height
    elem.style.height = startHeight
    requestAnimationFrame(() => {
      elem.style.transition = ''
      requestAnimationFrame(() => (elem.style.height = height))
    })
    elem.addEventListener('transitionend', () => (elem.style.height = ''))
  }, [refs])
  const toggle = useCallback((_id) => {
    setOpenStates(prev => ({ ...prev, [_id]: !prev[_id] }))
    handleCollapse(_id)
  }, [handleCollapse])
  const closeAll = useCallback(() => setOpenStates((state) => Object.keys(state).reduce((acc, cur) => ({ ...acc, [cur]: false }), {})), [])
  return { refs, openStates, toggle, closeAll }
}